// App version — single source of truth is package.json, injected by Vite's
// `define` (see vite.config.js -> __APP_VERSION__). The typeof guard keeps this
// safe in non-Vite contexts (e.g. node-run tests).
/* global __APP_VERSION__ */
export const APP_VERSION =
  typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '1.0.0';

export default APP_VERSION;
